import React from "react";

import * as fromProjects from "store/Projects";

import { a } from "@react-spring/web";
import { useAnimateInTrail } from "hooks/useAnimateInTrail";

interface IProps {
  animateIn: boolean;
  bar: fromProjects.IContentTimelineBar;
  numberOfStages: number;
  index: number;
}

export const Bar: React.FC<IProps> = ({
  animateIn,
  bar,
  numberOfStages,
  index,
  ...props
}) => {
  const previousStages = bar.startStage - 1;
  const currentStages = bar.endStage - bar.startStage + 1;
  const nextStages = numberOfStages - bar.endStage;

  const baseBarWidth = `((100% - 4px) / ${numberOfStages})`;

  const [animateInTrail] = useAnimateInTrail(animateIn, index + 4);

  const startBarStyles = {
    width: `calc(${baseBarWidth} * ${previousStages})`,
  };

  const endBarStyles = {
    width: `calc(${baseBarWidth} * ${nextStages})`,
  };

  const mainBarStyles = {
    width: `calc((${baseBarWidth} * ${currentStages}) + 4px)`,
  };

  const barBackgroundStyles = {
    backgroundColor: bar.backgroundColor,
    width: animateInTrail[index + 1].active.to((x) => `calc(100% * ${x})`),
    height: animateInTrail[index + 1].active.to((x) =>
      x < 0.2 ? `calc(500% * ${x})` : `100%`
    ),
  };

  const barTitleStyles = {
    opacity: animateInTrail[index + 3].active.to((x) => x),
  };

  return (
    <div className="row">
      <div className="startBar" style={startBarStyles} />
      <div className="bar" style={mainBarStyles}>
        <a.div className="background" style={barBackgroundStyles}>
          <a.div className="title" style={barTitleStyles}>
            {bar.text}
          </a.div>
        </a.div>
      </div>
      <div className="endBar" style={endBarStyles} />
    </div>
  );
};
